import React, { useState, useEffect } from "react";
import Class from "./Class";
import { getStrengthClass } from "../../../utils/rotateVideoLinks";

const SelectClass = ({ screen }) => {
  const [type, setType] = useState({ selection: null });
  const [strengthClass, setStrengthClass] = useState(null);

  const handleClick = (choice) => {
    setType(choice);
  };

  useEffect(() => {
    setStrengthClass(getStrengthClass());
    if(screen?.location?.mctEnabled !== true) {
      setType({selection: "Normal"})
    }
    //eslint-disable-next-line
  }, []);

  return (
    <>

      {type.selection === null && screen?.location?.mctEnabled && (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{
            height: "100vh", 
            width: "100vw",  
            textAlign: "center",
            backgroundColor: "#13102d"
          }}
        >
          <button
            className="btn btn-info mb-4"
            id="signature-selection"
            style={{
              border: "2px solid white",
              borderRadius: "15px",
              fontSize: "2rem",
              padding: "1.5rem",
              width: "80%",             
              maxWidth: "400px",      
              backgroundColor: "#ef3147",
              fontFamily: 'sans-serif'
            }}
            onClick={() => handleClick({ selection: "Normal" })}
          >
            SIGNATURE
          </button>
          <button
            className="btn btn-info mb-4"
            id="mashup-selection"
            style={{
              border: "2px solid white",
              borderRadius: "15px",
              fontSize: "2rem",
              padding: "1.5rem",
              width: "80%",
              maxWidth: "400px",
              backgroundColor: "#ef3147",
              fontFamily: 'sans-serif'
            }}
            onClick={() => handleClick({ selection: "Mashup" })}
          >
            MASH-UP
          </button>
           <button
            className="btn btn-info"
            id="strength-selection"
            style={{
              border: "2px solid white",
              borderRadius: "15px",
              fontSize: "2rem",
              padding: "1.5rem",
              width: "80%",
              maxWidth: "400px",
              backgroundColor: "#ef3147",
              fontFamily: 'sans-serif'
            }}
            onClick={() => handleClick({ selection: "Strength" })}
          >
            STRENGTH <span style={{color: "#212529", fontWeight: "bold"}}>({strengthClass && strengthClass[0]?.groupId})</span>
          </button>
        </div>
      )}

      {type.selection !== null && (
        <Class screen={screen} type={type} setType={setType} strengthClass={strengthClass}></Class>
      )}
    </>
  );
};

export default SelectClass;
